import { Component, ViewChild } from '@angular/core';
import { ExportCertificateListingComponent } from './export-certificate-listing/export-certificate-listing.component';

@Component({
  selector: 'app-export-certificate',
  templateUrl: './export-certificate.component.html',
  styleUrls: ['./export-certificate.component.scss']
})
export class ExportCertificateComponent {

  @ViewChild('certificateListing') certificateListingComponent!: ExportCertificateListingComponent;

  onCertificateAdded(): void {
    console.log('Certificate added successfully');
    // Trigger refresh of the certificate listing
    if (this.certificateListingComponent) {
      this.certificateListingComponent.onCertificateAdded();
    }
  }

  onCertificateUpdated(): void {
    console.log('Certificate updated successfully');
    // Trigger refresh of the certificate listing
    if (this.certificateListingComponent) {
      this.certificateListingComponent.onCertificateUpdated();
    }
  }
}
